import React from "react";

interface ModeRendererProps {
  brand: string;
  today: string;
  Copy: string;
}

export function VasarelyLvmhMode({ brand }: ModeRendererProps) {
  const width = 794;
  const height = 1123;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="lvmhGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#D4AF37", stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: "#FFD700", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#2F2F2F", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <rect width={width} height={height} fill="url(#lvmhGradient)" />
      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {Array.from({ length: 12 }).map((_, i) =>
          Array.from({ length: 16 }).map((_, j) => {
            const x = -300 + i * 50;
            const y = -400 + j * 50;
            return (
              <rect
                key={`lux-${i}-${j}`}
                x={x - 20}
                y={y - 20}
                width={40}
                height={40}
                fill="none"
                stroke="#FFD700"
                strokeWidth={1.5}
                opacity={0.2}
                rx={6}
              />
            );
          })
        )}
        {Array.from({ length: 16 }).map((_, c) => (
          <circle
            key={`gold-${c}`}
            cx={0}
            cy={0}
            r={(c + 1) * 25}
            fill="none"
            stroke="#FFFFFF"
            strokeWidth={c % 3 === 0 ? 2.5 : 1.5}
            opacity={0.3 - c * 0.014}
          />
        ))}
        <rect x={-50} y={-50} width={100} height={100} fill="none" stroke="#FFD700" strokeWidth={3} opacity={0.6} rx={8} />
        <circle cx={0} cy={0} r={35} fill="#D4AF37" opacity={0.4} />
      </g>
    </svg>
  );
};
